import * as React from 'react';
import EmbedCalender from '../components/EmbedCalender';

const EmbedCalenderScreen: React.FunctionComponent = () => {
  return (
    <div>
      <EmbedCalender />
    </div>
  );
};

export default EmbedCalenderScreen;
